// extracted by mini-css-extract-plugin
module.exports = {"title__wrapper":"styles_title__wrapper__QSqlY"};